import { Navigate, Route, Routes } from "react-router-dom";

import AnalyticsPageView from "./components/AnalyticsPageView";
import AppShell from "./components/AppShell";
import MarketingLayout from "./components/MarketingLayout";
import RequireAuth from "./components/RequireAuth";
import { useAuth } from "./context/AuthContext";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import DashboardPage from "./pages/DashboardPage";
import EntriesPage from "./pages/EntriesPage";
import ImportPage from "./pages/ImportPage";
import LandingPage from "./pages/LandingPage";
import LeaveRequestPage from "./pages/LeaveRequestPage";
import LeaveDocumentDetailPage from "./pages/LeaveDocumentDetailPage";
import LeaveDocumentMappingsPage from "./pages/LeaveDocumentMappingsPage";
import LeaveDocumentPage from "./pages/LeaveDocumentPage";
import LoginPage from "./pages/LoginPage";
import {
  AboutPage,
  ContactPage,
  EmployersPage,
  FaqPage,
  FeaturesPage,
  LegalPage,
  PricingPage,
} from "./pages/MarketingPages";
import OnboardingPage from "./pages/OnboardingPage";
import PlannerPage from "./pages/PlannerPage";
import RegisterPage from "./pages/RegisterPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import BalancePage from "./pages/BalancePage";
import SubscriptionPage from "./pages/SubscriptionPage";
import TeamInviteAcceptPage from "./pages/TeamInviteAcceptPage";
import TeamPage from "./pages/TeamPage";

function ProtectedLayout() {
  return (
    <RequireAuth>
      <WorkspaceProvider>
        <AppShell />
      </WorkspaceProvider>
    </RequireAuth>
  );
}

function AuthOnlyOnboarding() {
  return (
    <RequireAuth>
      <OnboardingPage />
    </RequireAuth>
  );
}

export default function App() {
  const { user } = useAuth();

  return (
    <>
      <AnalyticsPageView />
      <Routes>
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/prijzen" element={<PricingPage />} />
          <Route path="/functies" element={<FeaturesPage />} />
          <Route path="/voor-werkgevers" element={<EmployersPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/over-ons" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/cookies" element={<LegalPage kind="cookies" />} />
          <Route path="/algemene-voorwaarden" element={<LegalPage kind="terms" />} />
          <Route
            path="/voorwaarden"
            element={<Navigate to="/algemene-voorwaarden" replace />}
          />
          <Route
            path="/inloggen"
            element={!user ? <LoginPage /> : <Navigate to="/app" replace />}
          />
          <Route
            path="/registreren"
            element={!user ? <RegisterPage /> : <Navigate to="/app" replace />}
          />
        </Route>

        <Route path="/login" element={<Navigate to="/inloggen" replace />} />
        <Route path="/register" element={<Navigate to="/registreren" replace />} />
        <Route path="/onboarding" element={<AuthOnlyOnboarding />} />

        <Route path="/app" element={<ProtectedLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="planner" element={<PlannerPage />} />
          <Route path="balance" element={<BalancePage />} />
          <Route path="requests" element={<EntriesPage />} />
          <Route path="requests/new" element={<LeaveRequestPage />} />
          <Route path="requests/:entryId/edit" element={<LeaveRequestPage />} />
          <Route path="documents" element={<LeaveDocumentPage />} />
          <Route path="documents/mappings" element={<LeaveDocumentMappingsPage />} />
          <Route path="documents/:documentId" element={<LeaveDocumentDetailPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="import" element={<ImportPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="settings/abonnement" element={<SubscriptionPage />} />
        </Route>

        <Route path="/entries" element={<Navigate to="/app/requests" replace />} />
        <Route path="/teams" element={<Navigate to="/app/team" replace />} />
        <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
        <Route
          path="/team-invite/:token"
          element={
            <RequireAuth>
              <TeamInviteAcceptPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Navigate to={user ? "/app" : "/"} replace />} />
      </Routes>
    </>
  );
}
